import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";

import CompanyService from "@/core/services/company.service";
import SidebarService from "@/core/services/sidebar.service";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent,
  },
})
export default class CreateCompanyComponent extends Vue {
  companyService: any = new CompanyService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  emailevaluations: boolean = false;
  genericErr: any = [];
  businessList: any = [];
  name: string = "";
  manager: string = "";
  allowedUsersMap: string = "";
  allowedUsersShortMap: string = "";
  allowedUsersAct: string = "";
  logo: FormData = new FormData();
  businessId: string = "defaultGiro";

  mounted() {
    const _ = this;
    _.getBusiness();
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  getBusiness() {
    const _ = this;
    _.isLoading = true;
    _.companyService
      .getBusiness()
      .then((data: any) => {
        _.businessList = data["data"].businesses;
        _.businessList.sort(function(a, b) {
          return a.name.localeCompare(b.name);
        });
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
        _.isLoading = false;
      });
  }

  create() {
    const _ = this;
    _.genericErr = [];
    let company = _.logo;
    _.isLoading = true;
    const testParams = {
      name: _.name,
      businessId: _.businessId,
      manager: "erkalmar@gmail.com",
      surveys: [
        {
          surveyId: 1,
          users: 10,
          priority: 1,
        },
        {
          surveyId: 2,
          users: 10,
          priority: 2,
        },
        {
          surveyId: 3,
          users: 10,
          priority: 3,
        },
      ],
    };
    console.log(testParams, " ==testParams");
    _.companyService
      .create(testParams)
      .then((data: any) => {
        _.isSuccess = true;
        _.isErrorServer = false;
        _.error = false;
        _.modal = true;
        console.log(data, "-<")
        _.addLogo(data.data.company.id);
        setTimeout(() => {
          _.isLoading = false;
          _.$router.push(`${data["data"].company.id}/admins/create`);
        }, 2000);
      })
      .catch((err: any) => {
        _.modal = true;
        _.error = true;
        _.isErrorServer = true;
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  addLogo(companyId: string | number) {
    const _ = this;
    console.log(_.logo, " <- logo")
    _.companyService
    .addLogo(_.logo, companyId)
    .then((res: any) => {
      console.log(res, "<- res");
    })
  }

  changeLogo() {
    const _ = this;
    _.logo.append("file", document.querySelector(".logo").files[0]);
  }

  validations(manager = "", name = "") {
    const _ = this;
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    _.genericErr = [];
    if (!emailRegex.test(manager.toLowerCase()) && manager != "") {
      _.genericErr.push("Correo invalido");
    }
    if (name == "") {
      _.genericErr.push("Por favor escribe el nombre de la compañia");
    }
    if (_.genericErr.length > 0) {
      _.modal = true;
      _.error = true;
      return;
    }
    _.create();
  }
}
